/**
 * Mobile Product App Bar
 * Sticky bottom bar with quantity selector, dynamic price + add-to-cart CTA.
 * Works across ALL product templates (modern, doppel-modern,
 * zaun-modern, zaun-modern2, zaun-konfigurator).
 * Only active on mobile (≤ 989px).
 * Desktop is untouched.
 */
(function () {
  'use strict';

  /* ---- Bail on desktop ---- */
  if (window.innerWidth > 989) return;

  /* ---- Read settings from data attributes ---- */
  var wrapper = document.getElementById('MobileProductAppBar');
  if (!wrapper) return;

  var enableBar = wrapper.dataset.enableBar === 'true';
  var barBehavior = wrapper.dataset.barBehavior || 'above_nav';
  var showPrice = wrapper.dataset.showPrice === 'true';
  var logoOnly = wrapper.dataset.logoOnly === 'true';
  var hideBreadcrumbs = wrapper.dataset.hideBreadcrumbs === 'true';
  var isKonfiguratorStep = document.body.classList.contains('konfig-step-mode');

  /* ---- Add body classes ---- */
  document.body.classList.add('mobile-product-app-active');

  if (logoOnly) {
    document.body.classList.add('mobile-product-logo-only');
  }

  if (hideBreadcrumbs) {
    document.body.classList.add('mobile-product-hide-breadcrumbs');
  }

  /* Skip bar creation if konfigurator step mode is active (it has its own bar) */
  if (!enableBar || isKonfiguratorStep) return;

  document.body.classList.add('mobile-product-sticky-active');

  if (barBehavior === 'above_nav') {
    document.body.classList.add('mobile-product-bar-above-nav');
  } else if (barBehavior === 'replace_nav') {
    document.body.classList.add('mobile-product-bar-replace-nav');
  }

  /* ---- Find product form (universal) ---- */
  var productForm =
    document.getElementById('product-form-modern') ||
    document.getElementById('konfig-product-form') ||
    document.getElementById('product-form') ||
    document.querySelector('[data-product-form]') ||
    document.querySelector('form[action*="/cart/add"]');

  /* ---- Find price element (universal) ---- */
  var priceEl =
    document.getElementById('product-price') ||
    document.getElementById('konfig-total') ||
    document.querySelector('[data-price]') ||
    document.querySelector('.price-value') ||
    document.querySelector('.product-configurator__price') ||
    document.querySelector('.konfig-price');

  /* ---- Find add-to-cart button (universal) ---- */
  var addToCartBtn =
    document.getElementById('add-to-cart-btn') ||
    document.getElementById('konfig-add-to-cart') ||
    document.querySelector('[data-add-to-cart-btn]') ||
    (productForm && productForm.querySelector('button[type="submit"]'));

  /* ---- Find original quantity input (universal) ---- */
  var originalQtyInput =
    (productForm && productForm.querySelector('input[name="quantity"]')) ||
    document.querySelector('.quantity-input') ||
    document.querySelector('input[name="quantity"]');

  /* ---- Build bottom bar ---- */
  var bar = document.createElement('div');
  bar.className = 'mobile-product-bottom-bar';
  bar.id = 'MobileProductBottomBar';

  var innerHtml = '<div class="mobile-product-bottom-bar__inner">';

  if (showPrice) {
    innerHtml +=
      '<div class="mobile-product-bottom-bar__price">' +
        '<div class="mobile-product-bottom-bar__price-label">Preis</div>' +
        '<div class="mobile-product-bottom-bar__price-value" id="mobile-bar-price">' +
          (priceEl ? priceEl.textContent.trim() : '') +
        '</div>' +
      '</div>';
  }

  /* Quantity selector */
  innerHtml +=
    '<div class="mobile-product-bottom-bar__qty">' +
      '<button type="button" class="mobile-product-bottom-bar__qty-btn" id="mobile-bar-qty-minus" aria-label="Menge verringern">' +
        '<span class="material-symbols-outlined">remove</span>' +
      '</button>' +
      '<span class="mobile-product-bottom-bar__qty-value" id="mobile-bar-qty-value">1</span>' +
      '<button type="button" class="mobile-product-bottom-bar__qty-btn" id="mobile-bar-qty-plus" aria-label="Menge erhöhen">' +
        '<span class="material-symbols-outlined">add</span>' +
      '</button>' +
    '</div>';

  /* CTA button */
  innerHtml +=
    '<button type="button" class="mobile-product-bottom-bar__cta" id="mobile-bar-cta">' +
      '<span class="material-symbols-outlined">shopping_cart</span> ' +
      'In den Warenkorb' +
    '</button>';

  innerHtml += '</div>';
  bar.innerHTML = innerHtml;

  document.body.appendChild(bar);

  /* ---- Quantity logic ---- */
  var qtyValueEl = document.getElementById('mobile-bar-qty-value');
  var qtyMinusBtn = document.getElementById('mobile-bar-qty-minus');
  var qtyPlusBtn = document.getElementById('mobile-bar-qty-plus');
  var currentQty = 1;

  function syncQtyToOriginal() {
    if (originalQtyInput) {
      originalQtyInput.value = currentQty;
      originalQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateQtyDisplay() {
    if (qtyValueEl) {
      qtyValueEl.textContent = currentQty;
    }
  }

  if (qtyMinusBtn) {
    qtyMinusBtn.addEventListener('click', function () {
      if (currentQty > 1) {
        currentQty--;
        updateQtyDisplay();
        syncQtyToOriginal();
      }
    });
  }

  if (qtyPlusBtn) {
    qtyPlusBtn.addEventListener('click', function () {
      currentQty++;
      updateQtyDisplay();
      syncQtyToOriginal();
    });
  }

  /* Sync from original input if user changes it directly */
  if (originalQtyInput) {
    currentQty = parseInt(originalQtyInput.value) || 1;
    updateQtyDisplay();

    originalQtyInput.addEventListener('change', function () {
      var val = parseInt(originalQtyInput.value) || 1;
      if (val !== currentQty) {
        currentQty = val;
        updateQtyDisplay();
      }
    });
  }

  /* ---- Price sync ---- */
  var barPriceEl = document.getElementById('mobile-bar-price');

  function syncPrice() {
    if (!barPriceEl || !showPrice) return;

    var source =
      document.getElementById('product-price') ||
      document.getElementById('konfig-total') ||
      document.querySelector('[data-price]') ||
      document.querySelector('.price-value') ||
      document.querySelector('.product-configurator__price') ||
      document.querySelector('.konfig-price');

    if (source) {
      barPriceEl.textContent = source.textContent.trim();
    }
  }

  /* Observe price DOM changes */
  if (priceEl && window.MutationObserver && showPrice) {
    var observer = new MutationObserver(syncPrice);
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  /* Also listen for variant change events */
  document.querySelectorAll('.height-btn, .strength-option input, [data-variant-option], [data-option-btn]').forEach(function (el) {
    el.addEventListener('click', function () { setTimeout(syncPrice, 100); });
    el.addEventListener('change', function () { setTimeout(syncPrice, 100); });
  });

  /* Konfigurator selects/inputs */
  document.querySelectorAll('.konfig-select[data-option-index]').forEach(function (sel) {
    sel.addEventListener('change', function () { setTimeout(syncPrice, 100); });
  });

  ['konfig-zaunlaenge', 'konfig-pfosten-count', 'konfig-eckpfosten-count'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', function () { setTimeout(syncPrice, 100); });
      el.addEventListener('change', function () { setTimeout(syncPrice, 100); });
    }
  });

  document.querySelectorAll('.konfig-radio-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { setTimeout(syncPrice, 100); });
  });

  document.querySelectorAll('.config-button, .config-color').forEach(function (btn) {
    btn.addEventListener('click', function () { setTimeout(syncPrice, 200); });
  });

  /* ---- Add to cart click ---- */
  var ctaBtn = document.getElementById('mobile-bar-cta');

  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      syncQtyToOriginal();

      if (addToCartBtn) {
        addToCartBtn.click();
      } else if (productForm) {
        productForm.submit();
      }
    });
  }

  /* ---- Initial sync ---- */
  setTimeout(syncPrice, 300);
  setTimeout(syncPrice, 1000);

})();
